export const iconFontAwesomeReligionJedi = (
	<i className="fa-solid fa-jedi"></i>
);
